import React from 'react';

export function MppBrandingText() {
  return (
    <span><span className="bf-red">max</span>PRO<b>+</b></span>
  );
}
